import Script from 'next/script';

export function generateGoogleSearchConsoleMetaTag(
    googleSearchConsoleContent?: TrackingConfig['google_search_console_content']
) {
    if (!googleSearchConsoleContent) {
        return null;
    }

    return <meta name="google-site-verification" content={googleSearchConsoleContent} />;
}

export function generateGoogleAnalyticsScript(
    googleAnalyticsId?: TrackingConfig['google_analytics_id']
) {
    if (!googleAnalyticsId) {
        return null;
    }

    return (
        <>
            <Script
                strategy="afterInteractive"
                src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
            />
            <Script id="google-analytics" strategy="afterInteractive">
                {`
                    window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', '${googleAnalyticsId}');
                `}
            </Script>
        </>
    );
}

export function generateFacebookPixelScript(
    facebookPixelId?: TrackingConfig['facebook_pixel_id']
) {
    if (!facebookPixelId) {
        return null;
    }

    return (
        <Script id="facebook-pixel" strategy="afterInteractive">
            {`
                !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '${facebookPixelId}');
                    fbq('track', 'PageView');
            `}
        </Script>
    );
}
